import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { LeaveRequestApi, ToastStateHandler } from '../../../api';
import { GetAbsentColleaguesCount } from '../../../commonTypes/leaveRequest.types';
import { useTranslation } from '../../useTranslation';

const useHttpGetAbsentColleaguesCountOnMount = (from: string, to: string) => {
    const { t } = useTranslation('newNotifications');
    const leaveRequestApi: LeaveRequestApi = useContainer(LeaveRequestApi);
    const [data, setData] = useState<GetAbsentColleaguesCount>({ absentTodayCount: 0, absentPeriodCount: 0 });
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        const { exec, abort } = leaveRequestApi.getOrganizationMembersCount({
            query: { from, to },
            onSuccess: res => setData(res.body),
            onError: () => toastHandler.push('warn', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setReady(true),
        });
        exec();
        return abort;
    }, [leaveRequestApi]);

    return { data, isReady };
};

export default useHttpGetAbsentColleaguesCountOnMount;
